import { useTranslation } from 'react-i18next'

import { CircleFlag } from '@/components/ui/CircleFlag'
import { countryName, findCountry } from '@/lib/countries'

/** One end of a leg: the place, with its country's flag in front when there is
 *  one.
 *
 *  A component rather than the expression written twice, because the ABSENT
 *  case is the one that has to stay right: a leg with no country must render
 *  identically to how it did before the field existed — not with a globe, not
 *  with a reserved gap. Two copies of that condition is one that eventually
 *  renders a placeholder on every domestic road leg in the book.
 *
 *  The flag carries a `title`, which is the one place CircleFlag documents it
 *  as correct: nothing else on this line names the country. */
export function LegPlace({ name, country }: { name: string; country?: string }) {
  const { i18n } = useTranslation()
  const found = findCountry(country)

  if (!found) return <>{name}</>

  return (
    <>
      <CircleFlag
        code={found.code}
        size={14}
        title={countryName(found, i18n.language)}
        className="mr-1 inline-block align-[-2px]"
      />
      {name}
    </>
  )
}
